<template>
  <div>
    <div
      class="tw-w-full tw-mt-4 tw-p-4 tw-bg-orange-250 tw-rounded-lg tw-shadow tw-border-orange-350 tw-border"
    >
      <div class="tw-flex">
        <div class="tw-py-3">
          <SvgIcon class="tw-mr-3 tw-w-5 tw-h-5" name="info-icon-alt" />
        </div>
        <div>
          <p class="tw-mb-1 tw-font-medium tw-text-gray-800 tw-mt-2 tw-text-xl">
            Plan cancelled.
          </p>
          <p class="tw-text-gray-700 tw-mt-4 tw-text-xl">
            Your organisation's plan has been cancelled. Please upgrade your
            plan to continue to use Leave Dates. It will not be possible to
            request leave until you do this.
            <button class="btn btn-link tw-p-0" type="button" @click="upgrade">
              Upgrade
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeedsSubscription',

  methods: {
    upgrade() {
      window.location.href = `/settings/billing?company=${this.activeCompany.id}`
    },
  },
}
</script>
